class TestimonialsCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 50,
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("testimonials-carousel")) {
  customElements.define("testimonials-carousel", TestimonialsCarousel);
}
